<script>
export default {
  props: {
    value: Object,
  },
}
</script>

<template>
  <div>{{ value.message || $t(value.event) }}</div>
</template>
